<div class="btn-group col px-0">
	
	<input [(ngModel)]="val" [typeahead]="typeahead_list"  [typeaheadScrollable]="scrollable"
	[typeaheadOptionsInScrollableView]="scrollable_options_view" [typeaheadOptionsLimit]="options_limit" [typeaheadLatinize]="false" [typeaheadOptionField]="option_field" class="form-control"
	 placeholder="{{place_holder}}" [typeaheadMinLength]="0" (typeaheadOnSelect)="onSelect($event)" (keyup)="textChange(val)" [required]="requiredField">
	<span *ngIf="val.length != 0" class="searchclear fa fa-times" (click)="clearInput()"></span>
</div>